export default function StaticBackdrop() {
  return (
    <div className="fixed inset-0 z-0 overflow-hidden bg-[#0B0C10]" data-testid="static-backdrop" aria-hidden="true">
      <div className="absolute -top-40 left-1/4 h-[36rem] w-[36rem] rounded-full bg-[#8B5CF6]/20 blur-[140px]" />
      <div className="absolute bottom-0 right-0 h-[28rem] w-[28rem] rounded-full bg-[#06B6D4]/15 blur-[120px]" />
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="orb" />
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff06_1px,transparent_1px),linear-gradient(to_bottom,#ffffff06_1px,transparent_1px)] bg-[size:4rem_4rem]" />
    </div>
  );
}
